/**
 * 素材オプションの型定義.
 *
 * 注意: 素材マスター本体は Go 側 (materials テーブル, oneshot seed) を SSOT として管理しています.
 * フロントは API 経由で取得し、本ファイルは UI 側の型定義のみを保持します.
 */

/**
 * 対応部位.
 * Issue #1785 の 1st リリースでは屋根・外壁ベースエリアのみサポート.
 */
export type MaterialTargetPart = 'wall' | 'roof'

export interface MaterialOption {
  /** materials.id (proto bigint → bigint で保持) */
  id: bigint
  /** 対象部位 */
  targetPart: MaterialTargetPart
  /** メーカー名（フィルタ用） */
  manufacturer: string
  /** ブランド／シリーズ名 */
  brand: string
  /** 品番 */
  productCode: string
  /** カラー名 */
  colorName: string
  /** 見本画像の署名付きURL（一定時間で失効する） */
  thumbnailUrl: string
  /** 表示順 */
  displayOrder: number
}

/**
 * MaterialPalette のフィルタ用にメーカー一覧を抽出する.
 */
export const extractMaterialManufacturers = (materials: MaterialOption[]): string[] => {
  const seen = new Set<string>()
  for (const m of materials) {
    if (m.manufacturer) seen.add(m.manufacturer)
  }
  return Array.from(seen)
}

/**
 * メーカー・キーワード絞り込みで素材一覧をフィルタする.
 * keyword は brand / productCode / colorName のいずれかに部分一致 (大文字小文字無視) で比較.
 */
export const filterMaterials = (
  materials: MaterialOption[],
  selectedManufacturer: string | null,
  targetPart?: MaterialTargetPart,
  keyword?: string,
): MaterialOption[] => {
  const normalizedKeyword = keyword?.trim().toLowerCase() ?? ''
  return materials.filter(m => {
    if (targetPart && m.targetPart !== targetPart) return false
    if (selectedManufacturer && m.manufacturer !== selectedManufacturer) return false
    if (normalizedKeyword) {
      const haystack = `${m.brand} ${m.productCode} ${m.colorName}`.toLowerCase()
      if (!haystack.includes(normalizedKeyword)) return false
    }
    return true
  })
}
